import { useTranslation } from 'react-i18next';
import React, {MouseEvent} from 'react';
import {Modal, Typography} from "antd";
import Dragger from "antd/es/upload/Dragger";
import {InboxOutlined} from "@ant-design/icons";
import {DraggerProps} from "antd/lib/upload";
import './index.scss'

type ModalUploadProps = {
  propsDragger?: DraggerProps,
  downloadSample?: (e: MouseEvent) => void,
  title?: string,
  okText?: string,
  cancelText?: string,
  open?: boolean,
  isHasUsers?: boolean,
  isHasStudent?: boolean,
  checkError?: boolean,
  onOk?: () => void,
  onCancel?: () => void
}

// @ts-ignore
const ModalUploadFileExcel = ({
                                propsDragger,
                                downloadSample,
                                title,
                                open,
                                isHasUsers,
                                isHasStudent,
                                onOk,
                                onCancel,
                                cancelText,
                                okText,
                                checkError
                              }: ModalUploadProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        centered
        title={title}
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        cancelText={cancelText || t("Huỷ")}
        okText={okText || t("Xác nhận")}
        okButtonProps={{disabled: checkError}}
      >
        <Dragger {...propsDragger} className="upload-instructors"
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined/>
          </p>
          <p className="ant-upload-text">
            {t("Nhấn hoặc thả tệp lên từ máy tính của bạn")} <span className="link">{t("vào đây")}</span>
          </p>
          <p className="ant-upload-hint">
            {t("Định dạng tệp khả dụng: CSV (Tối đa 01 tệp - 10 MB)")}
          </p>
        </Dragger>
        <div className="modal-import--tutorial">
          <Typography.Text className="title-tutorial">
            {t("Hướng dẫn các bước nạp tệp danh sách")} {isHasUsers ? t('người dùng') : isHasStudent ? t('học viên') : t('trường')}
          </Typography.Text>
          <ol className="list-step--import">
            <li>
              <p>
                {t("Tải mẫu điền danh sách")} {isHasUsers ? t('người dùng') : isHasStudent ? t('học viên') : t('trường')} <a
                className="link"
                onClick={(e) => downloadSample ? downloadSample(e) : null}>{t("tại đây")}</a>
              </p>
            </li>
            <li>
              <p>
                {t("Điền danh sách")} {isHasUsers ? t('người dùng') : isHasStudent ? t('học viên') : t('trường')}. {isHasUsers ? t('Người dùng phải là Giảng viên, QTCS hoặc người dùng cấp bộ') : isHasStudent ? t('học viên') : t('Trường')} {t("đã đăng ký tài khoản trên hệ thống quản trị")} {process.env.REACT_APP_PROJECT_NAME || ""} {t("và lưu file theo định dạng .CSV")}
              </p>
            </li>
            <li>
              <p>
                {t("Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp")}
              </p>
            </li>
            <li>
              <p>
                {t("Kiểm tra tệp trước khi chọn “Xác nhận\"")}
              </p>
            </li>
          </ol>
        </div>
      </Modal>
    </>
  );
};

export default ModalUploadFileExcel;
